import { render, staticRenderFns } from "./Unities.vue?vue&type=template&id=4ba149d0&scoped=true&"
import script from "./Unities.vue?vue&type=script&lang=js&"
export * from "./Unities.vue?vue&type=script&lang=js&"
import style0 from "./Unities.vue?vue&type=style&index=0&id=4ba149d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba149d0",
  null
  
)

export default component.exports